import React from "react";
import {
  Paper,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableFooter,
  TableHead,
  TableRow,
} from "@material-ui/core";
import { TablePdf } from "../TablePdf/TablePdf";
import { TableHeader as TableHeaderPDF } from "@david.kucsai/react-pdf-table/lib/TableHeader";
import { TableCell as TableCellPDF } from "@david.kucsai/react-pdf-table/lib/TableCell";
import { TableBody as TableBodyPDF } from "@david.kucsai/react-pdf-table/lib/TableBody";
import { DataTableCell } from "@david.kucsai/react-pdf-table";
import GetCurrency from "../../helper/GetCurrency";

export default function ViewArticles(props) {
  let totalCount = 0;
  let totalAmount = 0;

  let articlesPlusSorted = Object.keys(props.articleLevel).sort((a, b) => {
    if (props.articleLevel[a].name < props.articleLevel[b].name) {
      return -1;
    } else if (props.articleLevel[a].name > props.articleLevel[b].name) {
      return 1;
    } else {
      return 0;
    }
  });
  let articles = articlesPlusSorted.map((plu) => {
    return props.articleLevel[plu];
  });

  let data = articles.map((article) => {
    totalCount += article.count;
    totalAmount += article.amount;
    return {
      name: article.name,
      count: article.count,
      amount: GetCurrency() + (article.amount / 100.0).toFixed(2),
    };
  });

  const getPdfView = () => {
    return (
      <TablePdf data={data}>
        <TableHeaderPDF>
          <TableCellPDF weighting={0.3}>Articles</TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            Aantal
          </TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            Bedrag
          </TableCellPDF>
        </TableHeaderPDF>
        <TableBodyPDF>
          <DataTableCell weighting={0.3} getContent={(r) => r.name} />
          <DataTableCell weighting={0.3} align={"right"} getContent={(r) => r.count} />
          <DataTableCell weighting={0.3} align={"right"} getContent={(r) => r.amount} />
        </TableBodyPDF>
        <TableHeaderPDF>
          <TableCellPDF weighting={0.3}>Totaal</TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            {totalCount}
          </TableCellPDF>
          <TableCellPDF weighting={0.3} align={"right"}>
            {GetCurrency() + (totalAmount / 100.0).toFixed(2)}
          </TableCellPDF>
        </TableHeaderPDF>
      </TablePdf>
    );
  };

  props.createPdf(getPdfView());

  return (
    <TableContainer component={Paper}>
      <Table>
        <TableHead>
          <TableRow>
            <TableCell>Articles</TableCell>
            <TableCell align={"right"}>Aantal</TableCell>
            <TableCell align={"right"}>Bedrag</TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {data.map((r) => {
            return (
              <TableRow>
                <TableCell>{r.name}</TableCell>
                <TableCell align={"right"}>{r.count}</TableCell>
                <TableCell align={"right"}>{r.amount}</TableCell>
              </TableRow>
            );
          })}
        </TableBody>
        <TableFooter>
          <TableRow>
            <TableCell>Totaal</TableCell>
            <TableCell align={"right"}>{totalCount}</TableCell>
            <TableCell align={"right"}>
              {GetCurrency()} {(totalAmount / 100.0).toFixed(2)}
            </TableCell>
          </TableRow>
        </TableFooter>
      </Table>
    </TableContainer>
  );
}
